import MoneroDaemonUpdateCheckResult from "./MoneroDaemonUpdateCheckResult";
/**
 * Models the result of downloading an update.
 */
export default class MoneroDaemonUpdateDownloadResult extends MoneroDaemonUpdateCheckResult {
    constructor(state) {
        super(state);
    }
    /**
     * Get the path the update was downloaded to.
     *
     * @return {string} is the path the update was downloaded to
     */
    getDownloadPath() {
        return this.downloadPath;
    }
    setDownloadPath(downloadPath) {
        this.downloadPath = downloadPath;
        return this;
    }
}
